import React from 'react';
import { Link } from 'react-router-dom';
import styles from './informativo.module.css'; 
import img1 from './img/informativo2.jpg';
import img2 from './img/informativo1.jpeg' 

function InformativoTrabalhistaBlog() {
  return (
    <div className={styles.paginaMateria}>
      <div className={styles.containerInterno}>
        
        <Link to="/blog" className={styles.btnVoltar}>
          &larr; Voltar para o Portal
        </Link>

        <header className={styles.cabecalhoMateria}>
          <span className={styles.tagMateria}>Informativo Trabalhista</span>
          <h1>Lei Nº 15.377/2026: Novas Obrigações de Conscientização e Prevenção nas Empresas</h1>
          <p className={styles.subtitulo}>Entenda a exigência legal sobre campanhas de saúde internas e o novo direito à ausência remunerada para exames preventivos.</p>
          <span className={styles.dataPublicacao}>Publicado em 08 de Abril de 2026</span>
        </header>

        <div className={`${styles.imagemDestaque} ${styles.imagemBanner}`}>
            <img src={img1} alt="Informativo Trabalhista sobre a Lei 15.377/2026 e conscientização em saúde" />
        </div> 

        <article className={styles.conteudoTexto}>
          <p>
            Prezados clientes,
          </p>
          <p>
            Com a publicação da <strong>Lei nº 15.377/2026</strong>, as empresas que possuam empregados registrados passam a ter a obrigação legal de promover ações internas de orientação e conscientização. O objetivo da nova legislação é fomentar a saúde preventiva no ambiente de trabalho.
          </p>
          
          <h2>Temas Obrigatórios para Conscientização</h2>
          <p>
            As campanhas promovidas pelo empregador deverão abordar obrigatoriamente os seguintes temas:
          </p>
          <ul>
            <li>Campanhas oficiais de vacinação;</li>
            <li>Prevenção e conscientização sobre o HPV;</li>
            <li>Prevenção do câncer de mama;</li>
            <li>Prevenção do câncer de colo do útero;</li>
            <li>Prevenção do câncer de próstata.</li>
          </ul>
          
          <h2>Direito à Ausência Remunerada</h2>
          <p>
            Além da divulgação destas informações, é indispensável comunicar aos colaboradores uma importante atualização em seus direitos. A legislação trabalhista agora assegura o direito de <strong>ausência remunerada por até 3 (três) dias</strong>, dentro de um período de 12 meses, para a realização de exames preventivos relacionados às finalidades previstas na referida lei.
          </p>
          <p>
            Vale ressaltar que a concessão deste benefício está estritamente condicionada à devida comprovação médica por parte do empregado.
          </p>
          
          <h2>Recomendação do Escritório e Segurança Jurídica</h2>
          <p>
            Para garantir a segurança da sua empresa e o pleno cumprimento da norma, recomendamos <strong>formalizar a comunicação</strong> aos colaboradores. Utilize os canais oficiais e rotineiros da organização, tais como: circular interna, e-mail corporativo, mural de avisos, Diálogo Diário de Segurança (DDS) ou grupo oficial de WhatsApp.
          </p>
          <p>
            É de suma importância manter a <strong>devida evidência documental</strong> do envio e recebimento destas comunicações para pronta apresentação em caso de eventual fiscalização dos órgãos competentes ou em uma possível reclamatória trabalhista.
          </p>
          
          <hr style={{ margin: '3rem 0', border: 'none', borderTop: '1px solid #e2dac9' }} />

          <p style={{ marginBottom: '3rem', fontWeight: 'bold', color: 'var(--color-blue, #002b36)' }}>
            Nos colocamos à disposição para auxiliar na elaboração do comunicado interno e na orientação detalhada dos novos procedimentos de Departamento Pessoal.
          </p>

          <div className={styles.imagemDestaque}>
            <img src={img2} alt="Informativo Trabalhista sobre a Lei 15.377/2026 e conscientização em saúde" />
          </div>          
        </article>

      </div>
    </div>
  );
}

export default InformativoTrabalhistaBlog;